import Vue from 'vue'
import Router from 'vue-router'
import Houses from "@/components/Houses";
import HouseEdit from "@/components/HouseEdit";
import Users from "@/components/Users";
import UserEdit from "@/components/UserEdit";
import Counters from "@/components/Counters";
import CounterEdit from "@/components/CounterEdit";
import Values from "@/components/Values";
import ValueEdit from "@/components/ValueEdit";
import Receipts from "@/components/Receipts";
import ReceiptEdit from "@/components/ReceiptEdit";
import Profile from "@/components/Profile";
import Statistics from "@/components/Statistics";

Vue.use(Router)

const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'Home',
            meta: {title: 'Home'},
            redirect: {name: 'Receipts'},
        },
        {
            path: '/profile',
            name: 'Profile',
            meta: {title: 'Профиль'},
            component: Profile
        },
        {
            path: '/statistics',
            name: 'Statistics',
            meta: {title: "Статистика"},
            component: Statistics
        },
        {
            path: '/receipts',
            name: 'Receipts',
            meta: {title: 'Показания'},
            component: Receipts,
        },
        {
            path: '/receiptEdit',
            name: 'ReceiptCreate',
            meta: {title: 'Показания счетчиков'},
            component: ReceiptEdit,
            props: true
        },
        {
            path: '/receiptEdit/:receiptId',
            name: 'ReceiptEdit',
            meta: {title: 'Показания счетчиков'},
            component: ReceiptEdit,
            props: true
        },
        {
            path: '/values',
            name: 'Values',
            component: Values,
        },
        {
            path: '/valueEdit/:valueId',
            name: 'ValueEdit',
            component: ValueEdit,
            props: true
        },
        {
            path: '/counters',
            name: 'Counters',
            meta: {title: 'Счетчики'},
            component: Counters,
        },
        {
            path: '/counterEdit/:counterId',
            name: 'CounterEdit',
            meta: {title: 'Изменение счетчика'},
            component: CounterEdit,
            props: true
        },
        {
            path: '/houses',
            name: 'Houses',
            meta: {title: "Дома/адреса"},
            component: Houses,
        },
        {
            path: '/houseEdit/:houseId',
            name: 'HouseEdit',
            meta: {title: "Изменение адреса"},
            component: HouseEdit,
            props: true
        },
        {
            path: '/users',
            name: 'Users',
            meta: {title: "Пользователи"},
            component: Users,
        },
        {
            path: '/userEdit/:userId',
            name: 'UserEdit',
            component: UserEdit,
            props: true
        },
    ]
})

export default router;